/** @jsx jsx */
import { Button, Input, jsx, Label } from "theme-ui";
import React, { useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import FlexCol from "../flex/flex";
import { useStaticQuery, graphql } from "gatsby";

type MailchimpFormData = {
  email: string;
};

export type MailchimpFormProps = {};
export const MailchimpForm: React.FC<MailchimpFormProps> = ({}) => {
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  });
  //get some mailchimp data
  const settings = useStaticQuery(graphql`
    {
      contentfulSiteSettings {
        mailchimpTags
        mailchimpList
      }
    }
  `);

  //setup react-hook-form
  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
  } = useForm<MailchimpFormData>({
    mode: "onBlur",
  });

  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      form.reset();
    }
  };

  //handle the for submission
  const handleOnSubmit = (e) => {
    const form = e.target;
    e.preventDefault();

    setServerState({ submitting: true, status: null });
    const formValues = getValues();
    const data = {
      list: settings.contentfulSiteSettings.mailchimpList,
      tags: settings.contentfulSiteSettings.mailchimpTags,
      email: formValues.email,
    };

    axios({
      method: "post",
      url: "/api/mailchimp",
      data: data,
    })
      .then((r) => {
        handleServerResponse(true, "Thanks!", form);
      })
      .catch((r) => {
        handleServerResponse(false, r.response.data.error, form);
      });
  };

  return (
    <form id="newsletter-form" name="newsletter-form" onSubmit={handleOnSubmit}>
      <FlexCol>
        <Label htmlFor="email" m={0}>
          email
        </Label>
        <Input
          type="email"
          //name="email"
          id="email"
          placeholder="Your email"
          {...register("email", {
            required: { value: true, message: "Email is required" },
            pattern: {
              value:
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: "Invalid email",
            },
          })}
        />
        {errors.email && (
          <p sx={{ variant: "forms.validationError" }}>
            {errors.email.message}
          </p>
        )}
      </FlexCol>
      <Button mt={[3]} type="submit" variant="primary.noIcon">
        Connect
      </Button>
    </form>
  );
};

export default MailchimpForm;
